"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initTabsWithSliders = initTabsWithSliders;
const tab_1 = __importDefault(require("./tab"));
function initTabsWithSliders(sectionsWithTabs) {
    sectionsWithTabs.forEach($section => {
        const $tabButtons = $section.getElementsByClassName('tab-buttons')[0];
        const $tabTabs = $section.getElementsByClassName('tab-panel')[0];
        const tabsWithSliders = !!$section.getElementsByClassName('swiper').length;
        if (tabsWithSliders) {
            new tab_1.default($tabButtons, $tabTabs, {
                afterInit: () => {
                    const $tabPanelItemActive = $tabTabs.getElementsByClassName('tab-panel__item--active')[0];
                    const $swiper = $tabPanelItemActive.getElementsByClassName('swiper')[0];
                    $swiper.swiper.navigation.update();
                },
                afterChange: () => {
                    $tabTabs
                        .querySelectorAll('.tab-panel__item:not(.tab-panel__item--active) .swiper')
                        .forEach(($swiper) => {
                        $swiper.swiper.navigation.disable();
                    });
                    const $tabPanelItemActive = $tabTabs.getElementsByClassName('tab-panel__item--active')[0];
                    const $swiper = $tabPanelItemActive.getElementsByClassName('swiper')[0];
                    $swiper.swiper.navigation.enable();
                },
            });
        }
        else {
            new tab_1.default($tabButtons, $tabTabs);
        }
    });
}
